"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playerInstance = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _video = _interopRequireDefault(require("video.js"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
require("!style-loader!css-loader!video.js/dist/video-js.css");
var _annotations = _interopRequireDefault(require("./plugins/annotations"));
var _chapters = _interopRequireDefault(require("./plugins/chapters"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // eslint-disable-line import/no-unresolved
// register plugins
_video["default"].registerPlugin('overlay', _annotations["default"]);
_video["default"].registerPlugin('chapters', _chapters["default"]);
var getPlayerInstance = function getPlayerInstance() {
  var videoNode = document.createElement('video');
  videoNode.className = 'video-js vjs-big-play-centered';
  var wrapper = document.createElement('div');
  wrapper.setAttribute('data-vjs-player', true);
  wrapper.appendChild(videoNode);
  var defaultVideoOptions = {
    autoplay: false,
    controls: true,
    loop: false,
    muted: false,
    fluid: true,
    options: {
      navigationUI: 'hide'
    }
  };
  var player = (0, _video["default"])(videoNode, defaultVideoOptions);
  player.chapters();

  // Create an event when subtitle changed
  {
    var timeout;
    player.textTracks().on('change', function action(event) {
      clearTimeout(timeout);
      var showingTracks = this.tracks_.filter(function (track) {
        return ['subtitles', 'captions'].includes(track.kind) && track.mode === 'showing';
      });
      if (showingTracks.length > 0) {
        timeout = setTimeout(function () {
          player.trigger('subtitleChanged', showingTracks[0]);
        }, 10);
      }
    });
  }
  return {
    wrapper: wrapper,
    player: player
  };
};
var globalWrapper;
var globalPlayer;
if (!globalPlayer) {
  var result = getPlayerInstance();
  globalWrapper = result.wrapper;
  globalPlayer = result.player;
}

// use the global player if available
// otherwise create a new player instance
var usePlayer = function usePlayer() {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    wrapper = _useState2[0],
    setWrapper = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    player = _useState4[0],
    setPlayer = _useState4[1];
  (0, _react.useEffect)(function () {
    if (globalPlayer.isTaken) {
      var _result = getPlayerInstance();
      setWrapper(_result.wrapper);
      setPlayer(_result.player);
      return function () {
        // wait a bit as wrapper is unmounted in parent component
        setTimeout(function () {
          _result.player.dispose();
          _result.wrapper.remove();
        }, 500);
      };
    }
    globalPlayer.isTaken = true;
    setWrapper(globalWrapper);
    setPlayer(globalPlayer);
    return function () {
      globalPlayer.isTaken = false;
    };
  }, []);
  return {
    wrapper: wrapper,
    player: player
  };
};
var Video = function Video(props) {
  var player = props.player,
    wrapper = props.wrapper,
    options = props.options;
  var placeholder = (0, _react.useRef)(null);
  var _useState5 = (0, _react.useState)('en'),
    _useState6 = _slicedToArray(_useState5, 2),
    language = _useState6[0],
    setLanguage = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    duration = _useState8[0],
    setDuration = _useState8[1];
  var onSubtitleChange = (0, _react.useCallback)(function (event, track) {
    setLanguage(track.language);
  }, []);
  var onDurationChange = (0, _react.useCallback)(function (event) {
    setDuration(player.duration() || 0);
  }, []);
  (0, _react.useEffect)(function () {
    if ('loop' in options) {
      player.loop(options.loop);
    }
  }, [options.loop]);
  (0, _react.useEffect)(function () {
    if ('controls' in options) {
      player.controls(options.controls);
    }
  }, [options.controls]);
  (0, _react.useEffect)(function () {
    if ('volume' in options) {
      player.volume(options.volume);
    }
  }, [options.volume]);
  (0, _react.useEffect)(function () {
    if ('playbackRate' in options) {
      player.playbackRate(options.playbackRate);
    }
  }, [options.playbackRate]);
  (0, _react.useEffect)(function () {
    if (!options.posters || options.posters.length === 0) {
      player.poster('');
    } else {
      var poster;
      var sortedPosters = _toConsumableArray(options.posters).sort(function (a, b) {
        return a.width - b.width;
      });

      // Find proper poster based on width
      if (sortedPosters.length > 1) {
        var playerWidth = placeholder.current.offsetWidth;
        if (playerWidth) {
          poster = sortedPosters.find(function (item) {
            return item.width && item.width >= playerWidth;
          });
        }
      }
      if (!poster) {
        poster = sortedPosters[sortedPosters.length - 1];
      }
      player.poster(poster.src);
    }
  }, [options.posters]);
  (0, _react.useEffect)(function () {
    var annotations;
    if (options.annotations) {
      annotations = options.annotations.find(function (item) {
        return item.language === language;
      });
      if (!annotations && language !== 'en') {
        annotations = options.annotations.find(function (item) {
          return item.language === 'en';
        });
      }
    }
    if (annotations && annotations.list) {
      player.overlay({
        overlays: annotations.list
      });
    } else {
      player.overlay({
        overlays: []
      });
    }
  }, [options.annotations, language]);
  (0, _react.useEffect)(function () {
    var chapters;
    if (options.chapters) {
      chapters = options.chapters.find(function (item) {
        return item.language === language;
      });
      if (!chapters && language !== 'en') {
        chapters = options.chapters.find(function (item) {
          return item.language === 'en';
        });
      }
    }
    if (chapters && chapters.list) {
      player.chapters().setList(chapters.list, duration);
    } else {
      player.chapters().setList();
    }
  }, [options.chapters, language, duration]);
  (0, _react.useEffect)(function () {
    var localOptions = options;
    if ('onEnded' in options) {
      player.on('ended', options.onEnded);
    }
    return function () {
      if ('onEnded' in localOptions) {
        player.off('ended', localOptions.onEnded);
      }
    };
  }, [options.onEnded]);
  (0, _react.useEffect)(function () {
    player.src(options.sources);
    if (options.autoplay) {
      player.play();
    }
    player.on('subtitleChanged', onSubtitleChange);
    player.on('durationchange', onDurationChange);
    return function () {
      player.pause();
      player.off('subtitleChanged', onSubtitleChange);
      player.off('durationchange', onDurationChange);
    };
  }, [options.autoplay, options.sources]);
  (0, _react.useEffect)(function () {
    var mountNode = placeholder.current;
    mountNode.appendChild(wrapper);
    return function () {
      mountNode.removeChild(wrapper);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: placeholder
  });
};
var Player = function Player(props) {
  var id = props.id;
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    producerOptions = _useState12[0],
    setProducerOptions = _useState12[1];
  var options = (0, _omit2["default"])(props, ['id']);
  var _usePlayer = usePlayer(),
    wrapper = _usePlayer.wrapper,
    player = _usePlayer.player;
  (0, _react.useEffect)(function () {
    var getProducerOptions = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result, data, videoSettings;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return _cccisdAxios["default"].get("https://producer.3cisd.com/api/producer/".concat(id));
            case 3:
              result = _context.sent;
              data = result.data.data;
              videoSettings = _objectSpread(_objectSpread(_objectSpread({
                sources: [{
                  src: data.videoUrl,
                  type: 'application/x-mpegURL'
                }]
              }, data.posterUrl && {
                posters: [{
                  src: data.posterUrl
                }]
              }), data.chapters && data.chapters.length > 0 && {
                chapters: data.chapters
              }), data.annotations && data.annotations.length > 0 && {
                annotations: data.annotations
              });
              setProducerOptions(videoSettings);
              setLoading(false);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getProducerOptions() {
        return _ref.apply(this, arguments);
      };
    }();
    if (id) {
      getProducerOptions();
    } else {
      setProducerOptions(null);
    }
  }, [id]);
  if (loading || !wrapper || !player || id && !producerOptions) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(Video, {
    options: _objectSpread(_objectSpread({}, producerOptions), options),
    wrapper: wrapper,
    player: player
  });
};
Player.propTypes = {
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  loop: _propTypes["default"].bool,
  controls: _propTypes["default"].bool,
  volume: _propTypes["default"].number,
  autoplay: _propTypes["default"].bool,
  sources: _propTypes["default"].array,
  onEnded: _propTypes["default"].func,
  onProgress: _propTypes["default"].func
};
var playerInstance = exports.playerInstance = globalPlayer;
var _default = exports["default"] = Player;